<template>
  <Dialog ref="dialog"
          width="600px"
          type="warning"
          icon="fas fa-exclamation"
          @confirm="addOrderSoc"
          :show-confirm="true"
          title="Revisa las soc a modificar">
    <div class="dialogSub" v-if="ordersToAdd.length > 0">
      <p><i class="el-icon-circle-plus"/>SOC A AGREGAR
        <span class="totalItemTimSuss">{{ordersToAdd.length}}</span>
      </p>
      <ol class="ordersListStyleDialog">
        <li type="none" v-for="(orderAdd, index) in ordersToAdd" :key="index.ordersToAdd">
          {{orderAdd}}
        </li>
      </ol>
    </div>
    <div class="dialogSub" v-if="ordersToDelete.length > 0">
      <p><i class="el-icon-remove"/>SOC A ELIMINAR
        <span class="totalItemTimSuss">{{ordersToDelete.length}}</span>
      </p>
      <ol class="ordersListStyleDialog">
        <li type="none" v-for="(orderDelete, index) in ordersToDelete"
            :key="index.ordersToDelete">{{orderDelete}}
        </li>
      </ol>
    </div>
    <div class="dialogSub" v-if="lpnToAdd.length > 0">
      <p><i class="el-icon-circle-plus"/>LPNs A AGREGAR
        <span class="totalItemTimSuss">{{lpnToAdd.length}}</span>
      </p>
      <ol class="ordersListStyleDialog">
        <li type="none" v-for="(lpnAdd, index) in lpnToAdd" :key="index.lpnToAdd">
          {{lpnAdd}}
        </li>
      </ol>
    </div>
    <div class="dialogSub" v-if="lpnToDelete.length > 0">
      <p><i class="el-icon-circle-plus"/>LPNs A ELIMINAR
        <span class="totalItemTimSuss">{{lpnToDelete.length}}</span>
      </p>
      <ol class="ordersListStyleDialog">
        <li type="none" v-for="(lpn, index) in lpnToDelete" :key="index.lpnToDelete">
          {{lpn}}
        </li>
      </ol>
    </div>
    <p class="dialogText">Esta modificación puede afectar el ETA propuesto inicialmente.
      <span class="focus">¿QUIERES MODIFICAR LA RUTA?</span>
    </p>
  </Dialog>
  <!--el-dialog custom-class="fb-dialog"
             :show-close="false"
             :visible.sync="visible">
    <span slot="title"><i class="el-icon-warning"/>Revisa las soc a modificar</span>
    <div class="dialogSub" v-if="ordersToAdd.length > 0">
      <p><i class="el-icon-circle-plus"/>SOC A AGREGAR
        <span class="totalItemTimSuss">{{ordersToAdd.length}}</span>
      </p>
      <ol class="ordersListStyleDialog">
        <li type="none" v-for="(orderAdd, index) in ordersToAdd" :key="index.ordersToAdd">
          {{orderAdd}}
        </li>
      </ol>
    </div>
    <div class="dialogSub" v-if="ordersToDelete.length > 0">
      <p><i class="el-icon-remove"/>SOC A ELIMINAR
        <span class="totalItemTimSuss">{{ordersToDelete.length}}</span>
      </p>
      <ol class="ordersListStyleDialog">
        <li type="none" v-for="(orderDelete, index) in ordersToDelete"
            :key="index.ordersToDelete">{{orderDelete}}
        </li>
      </ol>
    </div>
    <p class="dialogText">Esta modificación puede afectar el ETA propuesto inicialmente.
      <span class="focus">¿Quieres modificar la Ruta?</span>
    </p>
    <span slot="footer" class="dialog-footer">
        <el-button class="flat" @click="cancelModSoc()">CANCELAR</el-button>
        <el-button class="default" @click="addOrderSoc()">ACEPTAR</el-button>
      </span>
  </el-dialog-->
</template>

<script>
import Dialog from '../base/Dialog.vue';

export default {
  name: 'DialogChangeConfirm',
  components: {
    Dialog,
  },
  data() {
    return {
      routeId: NaN,
      ordersToAdd: [],
      ordersToDelete: [],
      lpnToAdd: [],
      lpnToDelete: [],
    };
  },
  methods: {
    normalizeList(list) {
      return Array.isArray(list) ? list : [];
    },
    addOrderSoc() {
      const ordersToAdd = this.normalizeList(this.ordersToAdd);
      const ordersToDelete = this.normalizeList(this.ordersToDelete);
      const lpnToAdd = this.normalizeList(this.lpnToAdd);
      const lpnToDelete = this.normalizeList(this.lpnToDelete);

      this.$refs.dialog.visible(false);
      this.$emit('confirm', this.routeId, ordersToAdd, ordersToDelete, lpnToAdd, lpnToDelete);
    },
    showConfirmDialog(routeId, ordersToAdd, ordersToDelete, lpnsToAdd, lpnToDelete) {
      this.routeId = routeId;
      this.ordersToAdd = this.normalizeList(ordersToAdd);
      this.ordersToDelete = this.normalizeList(ordersToDelete);
      this.lpnToAdd = this.normalizeList(lpnsToAdd);
      this.lpnToDelete = this.normalizeList(lpnToDelete);
      this.$refs.dialog.visible(true);
    },
  },
};
</script>

<style lang="scss" scoped>
  .dialogText {
    width: 85%;
    margin: auto;
    .focus {
      display: block;
      font-weight: 900;
      color: $fb-amber;
    }
  }
  .dialogItem {
    width: 85%;
    font-size: 11px;
    text-align: left;
    margin: 5px 0 5px 20px;
    .focus {
      display: block;
    }
  }
  .btnBottom {
    margin-top: 10px;
    float: right;
  }
  .tableStyle {
    box-sizing: border-box;
    overflow: hidden;
  }
  .grey {
    background-color: #606266;
    align-self: flex-end;
    height: 40px;
  }
  .linkStyle {
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.0);
    margin: 0;
    padding: 0;
  }
  .dialogTitle {
    padding: 0 40px;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    .el-icon-edit {
      color: #AAD500;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-warning {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-truck {
      color: #AAD500;
      font-size: 1.2em;
      margin-right: 0.5em;
      padding-right: 5px;
      vertical-align: baseline;
    }
  }
  .dialogRec {
    padding: 0 40px;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 700;
    margin: 30px 0 0 0;
  }
  .dialogSub {
    padding: 10px 40px 0 0;
    text-align: left;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 500;
    margin-top: 0;
    .el-icon-circle-plus {
      color: $fb-grey-light-50;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-remove {
      color: $fb-grey-light-50;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-success {
      color: #AAD500;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .ordersListStyleDialog {
      font-size: 11px;
      text-align: left;
    }
    .dialogTotalTim {
      padding: 10px 40px 0 0;
      text-align: center;
      font-size: 1em;
      text-transform: uppercase;
      font-weight: 800;
      margin-top: 0;
    }
  }
  .dialogError {
    padding: 10px 40px 0 0px;
    text-align: left;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    .el-icon-error {
      color: #f4511e;
      font-size: 1.2em;
      margin: 0 0.5em 0 0;
    }
  }
  .totalItemTim {
    color: white;
    font-size: 10px;
    padding: 1px 8px;
    background: $fb-amber;
    border-radius: 100%;
    -moz-border-radius: 1em;
    -webkit-border-radius: 1em;
    display: inline-block;
    font-weight: bold;
    line-height: 1.3em;
    margin-right: 14px;
    margin-left: 10px;
    text-align: center;
    width: 2.4em;
  }
  .totalItemTimSuss{
    color: white;
    font-size: 12px;
    padding: 1px 8px;
    background: $fb-amber;
    border-radius: 100%;
    -moz-border-radius: 1em;
    -webkit-border-radius: 1em;
    display: inline-block;
    font-weight: bold;
    line-height: 1.3em;
    margin-right: 14px;
    margin-left: 10px;
    margin-top: 5px;
    text-align: center;
    width: 2.4em;
  }
  .ordersListStyleDialog{
    margin-left: 10px;
  }
  .dialogItemSuss{
    width: 85%;
    font-size: 11px;
    text-align: left;
    margin: 5px 0 5px 30px;
    .focus {
      display: block;
    }
  }
  .clickeable {
    font-size: 7px;
    padding-top: 1px;
    margin-right: 3px;
    height: 23px;
    float: right;
    color: darkgray;
    cursor: pointer;
    animation: jumps .5s infinite;
  }
  .clickeable:hover {
    color: #AAD500;
    animation: none;
  }
  @keyframes jumps {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(4px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  td {
    padding: 2px 0px !important;
  }
  .point-map {
    color: #E6A23C;
    font-size: 8px;
    top: -2px;
  }
  .spCla {
    font-size: 10px;
    color: #707070;
    vertical-align: middle;
    margin-left: 6px;
  }

  .rotate-1 {
    webkit-animation: rotating 5s linear infinite;
    animation: rotating 5s linear infinite;
  }

  .el-icon-refresh-right {
    padding: 3px;
    color: white;
    border-radius: 50%;
    background-color: #09558f;
  }

  .refresh-send {
    font-size: 15px;
    color: #AAD500;
    background-color: transparent;
  }
</style>
